import { useState } from 'react';
import './flightbooking.css'; 

const InquiryForm = (props) => {
  const { isOpen, setIsOpen } = props;
  
  // State variables for Inquiry Form
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    address: '',
    email: '',
    phoneNumber: '',
    age: '',
    packageInterest: '',
    travelDate: ''
  });

  // const packages = [
  //   "Northern Areas (Hunza/Skardu)",
  //   "Cultural Heritage Tour",
  //   "Beach & Coastal Escape",
  //   "Religious Tourism",
  //   "Adventure & Trekking",
  //   "Custom Luxury Package"
  // ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitInquiry = (e) => {
    e.preventDefault();
    console.log('Inquiry Submitted:', formData);
    // Logic to send data to your backend would go here
    setIsOpen(false);
  };

  return (
    <div className="container">
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">
                <div className="modal-title-icon" aria-hidden="true">
                  <i className="fa fa-comment-dots" />
                </div>
                <div className="modal-title-text">
                  <h2>Inquiry Form</h2>
                  <p>Tell us what you're planning and we'll get back to you.</p>
                </div>
              </div>
              <button type="button" className="close-x" aria-label="Close" onClick={() => setIsOpen(false)}>&times;</button>
            </div>

            <form className="flight-form" onSubmit={handleSubmitInquiry}>

              <div className="form-section">
                {/* Name Row */}
                <div className="form-row">
                  <div className="input-group">
                    <label><i className="fa fa-user" aria-hidden="true" /> First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      className="form-input"
                      placeholder="John"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label><i className="fa fa-user" aria-hidden="true" /> Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      className="form-input"
                      placeholder="Doe"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Address Field */}
                <div className="form-row">
                  <div className="input-group" style={{ width: '100%' }}>
                    <label><i className="fa fa-map-marker-alt" aria-hidden="true" /> Address</label>
                    <input
                      type="text"
                      name="address"
                      className="form-input"
                      placeholder="123 Street, City, Country"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Contact Info Row */}
                <div className="form-row">
                  <div className="input-group">
                    <label><i className="fa fa-envelope" aria-hidden="true" /> Email Address</label>
                    <input
                      type="email"
                      name="email"
                      className="form-input"
                      placeholder="example@mail.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label><i className="fa fa-phone" aria-hidden="true" /> Phone Number</label>
                    <input
                      type="tel"
                      name="phoneNumber"
                      className="form-input"
                      placeholder="+92 300 1234567"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Age and Date Row */}
                <div className="form-row">
                  <div className="input-group">
                    <label><i className="fa fa-birthday-cake" aria-hidden="true" /> Age</label>
                    <input
                      type="number"
                      name="age"
                      className="form-input"
                      placeholder="Years"
                      value={formData.age}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label><i className="fa fa-calendar-alt" aria-hidden="true" /> Preferred Date</label>
                    <input
                      type="date"
                      name="travelDate"
                      className="form-input"
                      value={formData.travelDate}
                      min={new Date().toISOString().split('T')[0]}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Package Field */}
                <div className="form-row">
                  <div className="input-group" style={{ width: '100%' }}>
                    <label><i className="fa fa-suitcase-rolling" aria-hidden="true" /> Interested Package</label>
                    <input
                      type="text"
                      name="packageInterest"
                      className="form-input"
                      placeholder="e.g. Northern Areas, Umrah, Honeymoon..."
                      value={formData.packageInterest}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={() => setIsOpen(false)}>
                  Cancel
                </button>
                <button type="submit" className="search-btn">
                  <i className="fa fa-paper-plane" aria-hidden="true" /> Submit Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default InquiryForm;